<section class="flex h-full flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
  @if (hasActivity) {
    <div class="flex flex-row items-center justify-between">
      <div class="flex items-center gap-2">
        <h3 class="text-primary-900">
          {{ "calculator.activities" | transloco }}
        </h3>
      </div>
      <p-button
        [label]="'calculator.addActivity' | transloco"
        variant="outlined"
        (onClick)="addActivity()"
        icon="pi pi-plus"
      />
    </div>

    @for (entry of tripService.sortedActivities(); track entry.originalIndex) {
      <article class="flex flex-col gap-4 rounded-lg bg-white p-4">
        <div class="flex flex-1 flex-col gap-1">
          <div class="flex flex-1 flex-row items-center justify-between">
            <div class="flex flex-col">
              <div class="flex items-center gap-2">
                <div class="paragraph-med text-primary-950">
                  {{
                    entry.item.title ??
                    entry.item.customEmissionFactor?.name ??
                    (entry.item.type ? ("categoryType." + entry.item.type | transloco) : "")
                  }}
                </div>
                <app-item-validation-badge
                  scope="activity"
                  [index]="entry.originalIndex"
                  (badgeClick)="onItemValidationBadgeClick($event)"
                />
              </div>
              @if (entry.item.type) {
                <div class="text-paragraph-xs-reg text-greyscale-700">
                  {{ "categoryType." + entry.item.type | transloco }}
                </div>
              }
            </div>
            <div class="justify-end">
            <p-button
              icon="pi pi-ellipsis-v"
              (click)="op.toggle($event)"
              rounded
              variant="text"
              size="small"
            ></p-button>
            <p-popover #op>
              <div class="flex flex-col">
                <p-button
                  icon="pi pi-pencil"
                  [label]="'edit' | transloco"
                  variant="text"
                  (onClick)="editActivity(entry.originalIndex)"
                />
                <p-button
                  icon="pi pi-trash"
                  [label]="'delete' | transloco"
                  variant="text"
                  severity="danger"
                  (onClick)="confirmDelete(entry.originalIndex)"
                />
              </div>
            </p-popover>
          </div>
        </div>
      </div>
      <div class="flex flex-row gap-1 text-paragraph-s-med">
          @if (hasDays(entry.item)) {
            <span class="text-greyscale-600">{{
              ("travelBoards.duration" | transloco) + " :"
            }}</span
            ><span class="text-greyscale-900"
              >{{
                entry.item.days +
                  " " +
                  (entry.item.days! > 1
                    ? ("tripDashboard.days" | transloco)
                    : ("tripDashboard.day" | transloco))
              }}
            </span>
          } @else if (hasDistance(entry.item)) {
            <span class="text-greyscale-600">{{
              ("tripDashboard.distance" | transloco) + " :"
            }}</span
            ><span class="text-greyscale-900"
              >{{ entry.item.kilometers + " km" }}
            </span>
          } @else if (hasHours(entry.item)) {
            <span class="text-greyscale-600">{{
              ("travelBoards.duration" | transloco) + " :"
            }}</span
            ><span class="text-greyscale-900"
              >{{ entry.item.hours | durationFormat }}
            </span>
          } @else {}
        </div>
        @if ((entry.item.scheduledDays?.length ?? 0) > 0) {
          <div class="w-full border border-greyscale-100"></div>
          <div class="flex flex-wrap items-center gap-2">
            <span class="text-paragraph-s-med text-greyscale-600">{{
              "tripDashboard.scheduledOn" | transloco
            }}</span>
            @for (day of entry.item.scheduledDays; track $index) {
              <span
                class="rounded-xl bg-gray-100 p-1 px-2 text-paragraph-xs-reg text-greyscale-900"
                >{{ ("travelBoards.day" | transloco) + " " + day }}</span
              >
            }
          </div>
        }
      </article>
    }
  } @else {
    <app-prestation-empty-state
      [title]="'calculator.emptyState.activity.title' | transloco"
      [text]="'calculator.emptyState.activity.text' | transloco"
      [buttonLabel]="'calculator.addActivity' | transloco"
      [action]="addActivity"
    />
  }
</section>
